import DangerouslySetHtmlContent from "dangerously-set-html-content";
import { embedCode } from "@/react/components/SettingsApp/Emails/components/Forms/Edit/EmbedTab/utils";
import { usePunditUserContext } from "@/react/contexts";
import type { Form } from "@/react/types/Form";
import { classNames } from "@circle-react-shared/BuilderUI/utils/twMergeWithCNAndPrefix";

interface FormEmbedProps {
  form?: Form;
  isPreviewMode: boolean;
}

export const FormEmbed = ({ form, isPreviewMode }: FormEmbedProps) => {
  const { currentCommunity } = usePunditUserContext();
  const { full_url } = currentCommunity ?? {};
  const embedCodeText = form
    ? embedCode({
        formUid: form.uid,
        isPopup: false,
        currentCommunityFullUrl: full_url || "",
        isPreview: isPreviewMode,
        isUsedOnPages: true,
      })
    : "";
  return (
    <div
      className={classNames("wb-w-full", {
        "wb-pointer-events-none": isPreviewMode,
      })}
    >
      <DangerouslySetHtmlContent html={embedCodeText} />
    </div>
  );
};
